export * from './bundle-extensions-template';
